import React from "react";
import useTitle from "../hooks/UseTittle";

import blog1 from "../assects/images/blog1.jpg";
import blog2 from "../assects/images/blog2.jpg";
import blog3 from "../assects/images/blog3.jpg";
import blog4 from "../assects/images/blog4.jpg";

import { motion } from "framer-motion";

const Blogs = () => {
  useTitle("Mofazzel | Blogs");

  const parentVariant = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
        delayChildren: 0.4,
        staggerChildren: 0.2,
        damping: 30,
      },
    },
  };

  const item = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        damping: 100,
      },
    },
  };

  const blogs = [
    {
      img: blog1,
      date: "17 April",
      category: "Inspiration",
      title: "How to Own Your Audience by Creating an Email List.",
      bgColor: "#fcf4ff",
    },
    {
      img: blog2,
      date: "17 April",
      category: "Inspiration",
      title: "Top 10 Toolkits for Deep Learning in 2021.",
      bgColor: "#fff4f4",
    },
    {
      img: blog3,
      date: "17 April",
      category: "Inspiration",
      title: "he window know to say beside youT",
      bgColor: "#fff4f4",
    },
    {
      img: blog4,
      date: "17 April",
      category: "Inspiration",
      title: "Everything You Need to Know About Web Accessibility.",
      bgColor: "#fff4f4",
    },
  ];

  return (
    <>
      <motion.div
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        id="blogs"
        className="bg-b-drop"
      >
        <div className="container px-4 sm:px-5 md:px-10 lg:px-[60px]">
          <div className="py-12">
            <h2 className="after-effect after:left-32 lg:mt-0 ">Blogs</h2>
            <div className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 mt-[30px] grid gap-x-10 gap-y-7 mb-6">
              {/* <!-- blog items one start --> */}

              {blogs.map((blog, i) => (
                <motion.div
                  variants={item}
                  key={i}
                  className={`p-5 rounded-lg mb-2 h-full bg-[${blog.bgColor}] border shadow-sm`}
                >
                  <div className="overflow-hidden rounded-lg">
                    <a href="#ex1" rel="modal:open">
                      <img
                        className="rounded-lg w-full cursor-pointer transition duration-200 ease-in-out transform hover:scale-110"
                        src={blog.img}
                        alt="Blog"
                      />
                    </a>
                  </div>
                  <div className="flex mt-4 text-tiny text-gray-lite darkk:text-[#A6A6A6]">
                    <span>17 April</span>
                    <span className="dot-icon">Inspiration</span>
                  </div>
                  <h3 className="text-lg font-medium  duration-300 transition cursor-pointer mt-3 pr-4 hover:text-[#FA5252] darkk:hover:text-[#FA5252]">
                    <a href="#ex1" rel="modal:open">
                      How to Own Your Audience by Creating an Email List.
                    </a>
                  </h3>
                </motion.div>
              ))}

              {/* <!-- blog items one end --> */}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Blogs;
